export default __webpack_public_path__ + "static/media/12.a19409df.webp";